/**
 * 展示错误提示
 * @param {*} element 元素
 * @param {String} msg 错误提示信息
 */
export const showTip = (element, msg) => {
  // 新旧值不一致，弹出tip提示用户
  const parentElement = element.parentNode
  if (parentElement.getElementsByClassName('input-number-tip').length === 0) {
    // 适配不同大小的el-input
    const parentClassName = parentElement.className
    const tipSize = generateSize(parentClassName)
    // 生成tip元素
    const tip = createTip(msg, tipSize)
    parentElement.appendChild(tip)
    setTimeout(() => {
      parentElement.removeChild(tip)
    }, 1500)
  }
}

/**
 * 生成不同尺寸el-input的tip class
 * @param {String} className 元素Class
 * @returns HTML Class
 */
const generateSize = (className) => {
  let tipSize = 'small'
  if (className.indexOf('el-input--mini') >= 0) {
    tipSize = 'mini'
  } else if (className.indexOf('el-input--medium') >= 0) {
    tipSize = 'medium'
  }
  return tipSize
}

/**
 * 创建提示元素
 * @param {String} msg 提示信息
 * @param {String} size 尺寸
 * @returns HTML Dom
 */
const createTip = (msg, size) => {
  const tip = document.createElement('div')
  tip.className = `input-number-tip input-number-tip-${size}`
  tip.innerHTML = msg
  return tip
}
